export default __webpack_public_path__ + "static/media/aeroplane.1e6cb406.jpg";